<template>
  <div v-if="isTemplatePath" class="wenet-button-container">
    <el-dropdown @command="handleLinkToTemplate" style="margin-left: 100px">
      <el-button type="primary">
        点击导入可视化模板
        <i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="basic">导入基础模板</el-dropdown-item>
        <el-dropdown-item v-for="menu in localMenuTreeList" :command="menu.id" :key="menu.id">
          导入{{ menu.name }}
        </el-dropdown-item>
        <el-dropdown-item command="edit" divided>进入可视化编辑</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { isString, isArray } from 'lodash';
import { basicTemplate, localMenuTreeList } from 'nges-common/src/layout/nges-mcm-ui/template.mjs';

export default {
  props: {
    menuData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      localMenuTreeList,
    };
  },
  computed: {
    isTemplatePath() {
      // json_type: 1,历史数据
      const menuData = this.menuData || {};
      return (
        (menuData.platform === 1 || menuData.platform === 3) &&
        (menuData.json_type === 1 || menuData.path === '/pages/article/template/index')
      );
    },
    pagelets() {
      try {
        const layoutJson = this.menuData?.layout_json;
        if (layoutJson && isString(layoutJson)) {
          return JSON.parse(layoutJson);
        }
        if (layoutJson && isArray(layoutJson)) {
          return layoutJson;
        }
      } catch (error) {
        console.error(error);
      }

      return [];
    },
  },
  methods: {
    isError() {
      const errorMsg = this.processPageletsToValid();
      if (errorMsg) {
        this.$message({ type: 'warning', message: errorMsg });
        return true;
      }
      return false;
    },
    handleLinkToTemplate(command) {
      if (command === 'edit') {
        this.openDraggablePlatform();
      } else if (command === 'basic') {
        this.menuData.layout_json = JSON.stringify([basicTemplate]);
      } else {
        const data = localMenuTreeList.find((item) => item.id === command);
        this.menuData.layout_json = data.stable_layout_json;
      }
    },
    openDraggablePlatform() {
      if (this.menuData.id) {
        const routerUrl = this.$router.resolve({
          path: `/draggablePlatform/${this.menuData.id}`,
        });
        window.open(routerUrl.href, '_blank');
      } else {
        this.$message({
          type: 'warning',
          message: '请先创建菜单后，再进行模板编辑!',
        });
      }
    },

    // 纠错处理, 处理componentId & 不支持的组件 & 头部组件 以及 文章组件
    processPageletsToValid() {
      if (!this.isTemplatePath) {
        return;
      }

      const cacheIds = {};
      const componentList = [];
      const { pagelets } = this;
      for (let i = 0; i < pagelets.length; i++) {
        const pagelet = pagelets[i];
        const errMsg = this.checkTemplateJsonIsValid(pagelet.layout);
        if (errMsg) {
          return errMsg;
        }
        this.processPageletsLayoutComponentId(pagelet.layout, cacheIds, componentList);
      }

      // 头部组件
      if (cacheIds.NgTopContent !== undefined && cacheIds.NgTopContent > 0) {
        return '请删除多余的【顶部区域】组件, 且放置在布局最前面';
      }
      if (cacheIds.NgTopContent !== undefined && componentList[0] !== 'NgTopContent') {
        return '请将【顶部区域】组件放置在布局最前面';
      }
      if (cacheIds.NgTopContent === undefined) {
        return '请至少添加一个【顶部区域】组件, 且放置在布局最前面';
      }
      // 列表组件
      if (cacheIds.NgArticleListGroup !== undefined && cacheIds.NgArticleListGroup > 0) {
        return '请删除多余的【列表】组件, 且放置在布局最后面';
      }
      if (
        cacheIds.NgArticleListGroup !== undefined &&
        componentList[componentList.length - 1] !== 'NgArticleListGroup'
      ) {
        return '请将【列表】组件放置在布局最后面';
      }
    },
    checkTemplateJsonIsValid(layout) {
      if (!layout?.children?.length) {
        return '请检查页面布局, 模板布局为空, 请联系管理员';
      }

      for (let i = 0; i < layout.children.length; i++) {
        const item = layout.children[i];
        if (!item.type || !item.componentId) {
          return `请检查页面布局, layout.children 第${i + 1}个type/componentId为空, 请联系管理员`;
        }
        // if (item.children?.length) {
        //   return `请检查页面布局, layout.children 第${i + 1}个 ${
        //     item.componentId
        //   } 存在children, 发布到小程序后丢失布局, 请联系管理员`;
        // }
      }
    },
    processPageletsLayoutComponentId(layout, cacheIds = {}, componentList = []) {
      if (layout.type.startsWith('w-')) {
        // eslint-disable-next-line no-param-reassign
        layout.type = 'NgLayoutGroup';
      }
      if (!layout.type.startsWith('NgLayout')) {
        componentList.push(layout.type);
      }
      let id = cacheIds[layout.type];
      if (id === undefined) {
        id = 0;
      } else {
        id++;
      }
      // eslint-disable-next-line no-param-reassign
      cacheIds[layout.type] = id;
      // eslint-disable-next-line no-param-reassign
      layout.componentId = layout.type + id;

      layout?.children?.forEach((item) => {
        this.processPageletsLayoutComponentId(item, cacheIds, componentList);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/button.scss';

.wenet-button-container {
  display: flex;
  margin-top: 10px;
  ::v-deep {
    .el-dropdown {
      margin-left: 0 !important;
    }
  }
}
</style>
